import Component from '../core/Component'
import EventBus from '../core/EventBus'

export default class ForgottenPassword extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            login: null,
            forgot: null,
            toggles: []
        }
    }

    prepare() {
        this.ref.toggles.forEach(element => {
            element.addEventListener('click', event => {
                event.preventDefault()
                this.switch()
            })
        })

        this.reset()
        EventBus.on('modal:cose', ::this.reset)
        EventBus.on('modalopener', this.handleModalopener)
    }

    handleModalopener = data => {
        if (data?.element?.dataset?.view === 'forgotten-password') {
            this.switch()
        }
    }

    reset() {
        this.ref.login.style.display = 'block'
        this.ref.forgot.style.display = 'none'
    }

    switch() {
        if (this.ref.login.style.display !== 'none') {
            this.ref.login.style.display = 'none'
            this.ref.forgot.style.display = 'block'
        } else {
            this.reset()
        }

    }
}
